module.exports = __webpack_public_path__ + "media/images/flags/32/Togo-ad6ff7de4eebcadbfa1ce44d3b725d9c.png";